import Vue from 'vue';
import VueRouter from 'vue-router';
import { setPageTitle } from '@/utils/helpers';
import { checkLogin } from '@/utils/helpers/login-role';
import logger from '@/core/logger';
import { getPageViewParams } from '@/utils/helpers/page-dictionary';
import store from '@/store/index';
import javascriptBridge from '../core/lib/javascript-bridge';
import routes from './routes';

Vue.use(VueRouter);

let uniqueID; // logger-preview记录的唯一id
let eventLabel; // pageView传参

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

// 全局后置守卫
router.afterEach((to) => {
  Vue.nextTick(() => {
    Vue.prototype.$sensors.quick('autoTrackSinglePage');
  });

  if (!javascriptBridge.device.swjApp) {
    // 进入页面，新增一条页面埋点记录
    uniqueID = logger.log({
      event_Type: 0, // pageview
      event_Label: getPageViewParams(to),
      action_Type: 'pageview_APP_native',
    });
  }
});

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    // 设置页面标题
    setPageTitle(to.meta.title);
  }

  if (!javascriptBridge.device.swjApp) {
    if (uniqueID) {
      // 2、进入新页面，刷新上一条页面埋点记录
      logger.log({
        event_Unique_Id: uniqueID,
        event_Type: 0, // pageview
        event_Label: getPageViewParams(from),
        action_Type: 'pageview_APP_native',
      });
    } else {
    // 1、直接跳出页面时，走beforeunload发出数据
      eventLabel = getPageViewParams(to);
    }

    // app外需要sso登录后才能访问的页面
    if (to.meta && to.meta.requiredLogin) {
      const isLogin = checkLogin();
      // 已登录但没有用户信息的页面，获取用户信息
      if (isLogin && !store.state.user.currentUser) {
        await store.dispatch('user/getCurrentUser');
      }
    }
  }
  next();
});

window.addEventListener('beforeunload', () => {
  if (!javascriptBridge.device.swjApp && eventLabel) {
    logger.log({
      event_Unique_Id: uniqueID,
      event_Type: 0, // pageview
      event_Label: eventLabel,
      action_Type: 'pageview_APP_native',
    });
  }
});

export default router;
